<template>
  <div>
    <a-modal
      class="copy-box"
      :title="
        !dataMove && !templateMove ? $t(`button.copyLabel`) : $t(`button.move`)
      "
      centered
      :visible="copyVisible"
      :cancelText="$t(`button.cancel`)"
      :okText="$t(`button.save`)"
      @ok="handleCopy"
      @cancel="handCancel"
    >
      <div v-if="!dataMove && !templateMove" class="copy-title">
        {{ $t(`label.label16`) }}：
      </div>
      <a-input v-if="!dataMove && !templateMove" v-model:value="copyValue" />
      <div class="copy-title" v-if="!dataMove && !templateMove">
        {{ $t(`label.label17`) }}：
      </div>
      <div class="copy-title" v-else>{{ $t(`label.label18`) }}：</div>
      <div class="file-nav">
        <div
          v-for="(item, index) in fileList"
          :key="index"
          class="file"
          @click="handleFile(index)"
          :style="{
            background: index == selectIndex ? 'rgba(0, 53, 145, 0.1)' : '',
          }"
        >
          <FolderFilled />
          <span class="file-name">{{ item.name }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { FolderFilled } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import {
  defineComponent,
  ref,
  watch,
  getCurrentInstance,
  reactive,
  toRefs,
} from "vue";

export default defineComponent({
  components: {
    FolderFilled,
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));

    const state = reactive({
      fileList: [],
      selectIndex: 0,
      selectId: "",
      copyVisible: false,
      type: "",
      value: {},
      copyValue: proxy.$t(`label.label16`),
      dataMove: false,
      templateMove: false,
      MemberDiaRef: null,
    });

    const show = (type, value, MemberDiaRef) => {
      setTitle(type);
      getList();
      state.type = type;
      state.value = value;
      state.copyValue = value.name;
      state.copyVisible = true;
      state.MemberDiaRef = MemberDiaRef;
    };
    //设置标题
    const setTitle = (type) => {
      switch (type) {
        case "cloudDataFileMove":
          state.dataMove = true;
          break;
        case "templateMove":
          state.templateMove = true;
          break;
      }
    };

    // 获取文件夹列表
    const getList = () => {
      if (state.dataMove) {
        let obj = {
          user_id: userInfo.userid,
          type: 0,
        };
        axios("/api/tem.app_public/getCloudDataList", obj).then((res) => {
          state.fileList = res;
          state.selectId = state.fileList[0].id;
        });
      } else {
        let obj = {
          user_id: userInfo.userid,
        };
        axios("/api/tem.app_public/getUserTemList", obj).then((res) => {
          state.fileList = res;
          state.selectId = state.fileList[0].id;
        });
      }
    };

    const handleCopy = () => {
      if (!state.dataMove && !state.templateMove) {
        if (state.copyValue == "") {
          message.error(proxy.$t(`tips.tip41`));
          retrun;
        }
        var reg = new RegExp('[\\\\/:*?"<>|]');
        if (reg.test(state.copyValue)) {
          message.error(proxy.$t(`tips.tip42`) + '\\/:*?"<>|');
          return;
        }
      }
      switch (state.type) {
        //移动云端数据
        case "cloudDataFileMove":
          axios("/api/tem.app_public/editCloudFile", {
            id: state.value.id,
            user_id: userInfo.userid,
            tid: state.selectId,
          })
            .then((res) => {
              message.success(proxy.$t(`tips.tip57`));
              context.emit("refreshFile");
              handCancel();
            })
            .catch((err) => {});
          break;
        //复制云端模板
        case "templateCopy":
          axios("/api/tem.app_public/saveToPrivate", {
            id: state.value.id,
            name: state.copyValue,
            user_id: userInfo.userid,
            parent_id: state.selectId,
            platform: 2,
          })
            .then((res) => {
              message.success(proxy.$t(`tips.tip35`));
              context.emit("refreshFile");
              handCancel();
            })
            .catch((err) => {
              if (err.code == 402) {
                handCancel();
                if (process.env.VUE_APP_VERSION == "hprt") {
                  setTimeout(() => {
                    state.MemberDiaRef.show(err.message);
                  }, 500);
                }
              }
            });
          break;
        //移动云端模板
        case "templateMove":
          axios("/api/tem.app_public/editUserTemplate", {
            id: state.value.id,
            user_id: userInfo.userid,
            parent_id: state.selectId,
            platform: 2,
          }).then((res) => {
            message.success(proxy.$t(`tips.tip57`));
            context.emit("refreshFile");
            handCancel();
          });
          break;
        // 保存标签至云端模板
        case "templateSaveTo":
          axios("/api/tem.app_public/saveToLocal", {
            user_id: userInfo.userid,
            id: state.value.id,
            name: state.copyValue,
            parent_id: state.selectId,
            platform: 2,
          })
            .then((res) => {
              message.success(proxy.$t(`tips.tip58`));
              axios("/api/tem.app_public/addDowTem", {
                id: state.value.id,
              }).then((res) => {
                console.log("模板下载记录添加成功");
              });
              axios("/api/tem.app_public/userUseTem", {
              id: state.value.id,
              user_id: userInfo.userid,
            }).then((res) => {
              console.log('模板使用记录添加成功')
            });
              handCancel();
            })
            .catch((err) => {
              if (err.code == 402) {
                handCancel();
                if (process.env.VUE_APP_VERSION == "hprt") {
                  setTimeout(() => {
                    state.MemberDiaRef.show(err.message);
                  }, 500);
                }
              }
            });
          break;
      }
    };
    const handleFile = (index) => {
      state.selectIndex = index;
      state.selectId = state.fileList[index].id;
    };
    const handCancel = () => {
      state.copyVisible = false;
      state.copyValue = proxy.$t(`label.label16`);
      state.selectIndex = 0;
      state.selectId = "";
      state.templateMove = false;
      state.dataMove = false;
    };
    return {
      ...toRefs(state),
      show,
      handleCopy,
      handCancel,
      handleFile,
    };
  },
});
</script>
<style scoped>
.copy-title {
  height: 24px;
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
  margin-bottom: 16px;
  margin-top: 32px;
}
.file-nav {
  width: 100%;
  height: 144px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d6dce6;
  overflow: hidden;
  overflow-y: auto;
}
.file {
  width: calc(100% - 20px);
  height: 56px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 4px 5px 16px;
  cursor: pointer;
}
.file:hover {
  background-color: rgba(0, 53, 145, 0.1);
}
.file ::v-deep(.anticon) {
  color: #507bc4;
  font-size: 32px;
  padding-left: 20px;
}
.file-name {
  height: 24px;
  font-size: 16px;
  color: #1a1d21;
  line-height: 24px;
  margin-left: 12px;
}
@media only screen and (max-width: 1300px) {
  .copy-title {
    height: 16px;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 10px;
    margin-top: 21px;
  }
  .file-nav {
    height: 96px;
  }
  .file {
    width: calc(100% - 14px);
    height: 37px;
    margin: 5px 4px 5px 10px;
  }

  .file ::v-deep(.anticon) {
    font-size: 21px;
    padding-left: 14px;
  }
  .file-name {
    height: 16px;
    font-size: 10px;
    line-height: 16px;
    margin-left: 8px;
  }
}
</style>
